const ITEMS = [
  "Preventive Maintenance AC",
  "Maintenance HVAC",
  "AC Cleaning",
  "Troubleshooting",
  "Kontrak Maintenance",
  "Survey & Assessment",
  "Service AC Komersial",
  "Maintenance AC Kantor",
  "Maintenance AC Gedung",
];

/**
 * Marquee — satu strip editorial yang bergerak lambat (CSS-only, ringan).
 */
export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="border-y border-slate-200 bg-white py-6 overflow-hidden"
      aria-hidden="true"
    >
      <div className="flex w-max animate-[marquee_38s_linear_infinite] items-center gap-10 whitespace-nowrap will-change-transform">
        {loop.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="text-xl font-extrabold uppercase tracking-tight text-slate-300 sm:text-2xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 flex-none rounded-full bg-[#E0A400]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
